<template>
  <div class="vrow">
    <!-- Correct Score -->
    <template v-if="selMarket == 'cs'">
      <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }">
        {{ event.tacapt }}
      </div>
      <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }">
        <template v-if="!simpleSport">
          {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.DRAW'] }}
        </template>
        <template v-else>
          {{ sportAllBetLang['ALL_BET.LBL_DRAW'] }}
        </template>
      </div>
      <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }">
        {{ event.tbcapt }}
      </div>
      <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg highlight-t" :style="{ width: widthColumn[1] + 'px !important' }">
        {{ event.tacapt }}
      </div>
      <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg highlight-t" :style="{ width: widthColumn[1] + 'px !important' }">
        <template v-if="!simpleSport">
          {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.1H.DRAW'] }}
        </template>
        <template v-else>
          {{ sportAllBetLang['ALL_BET.LBL_DRAW'] }}
        </template>
      </div>
      <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg highlight-t" :style="{ width: widthColumn[1] + 'px !important' }">
        {{ event.tbcapt }}
      </div>
      <template v-if="isUnfold">
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }" v-if="widthColumn[3]==0"></div>
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }" v-if="widthColumn[3]<2"></div>
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
      </template>
    </template>
    <template v-if="selMarket == 'onex2btts'">
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: (widthColumn[1] * 3) + 'px !important' }">
          {{  sportAllBetLang['ALL_BET.SUBHEADER_1X2_BTTS'] }}
          <!-- {{  sportAllBetLang['ALL_BET.SUBHEADER_FT_1x2'] }} & {{  sportAllBetLang['ALL_BET.SUBHEADER_BTTS'] }} -->
        </div>
        <!-- <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt bluebg" :style="{ width: (widthColumn[1] * 3 ) + 'px !important' }">
        </div> -->
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg highlight-t" :style="{ width: (widthColumn[1] * 3) + 'px !important' }">
          {{  sportAllBetLang['ALL_BET.SUBHEADER_DBCH_BTTS'] }}
        </div>
        <template v-if="isUnfold">
          <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }" v-if="widthColumn[3]==0"></div>
          <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }" v-if="widthColumn[3]<2"></div>
          <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
      </template>
    </template>
    <template v-if="selMarket == 'booking' || selMarket == 'corner'">
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }">
          {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.1X2'] }}
        </div>
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }">
          {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.HDP'] }}
        </div>
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }">
          {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FT.O/U'] }}
        </div>
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg" style="line-height: 15px; padding-top: 5px;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div>{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.1X2'] }}</div>
          <span class="highlight-t">
            {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'] }}
          </span>
        </div>
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg" style="line-height: 15px; padding-top: 5px;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div>{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.HDP'] }}</div>
          <span class="highlight-t">
            {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'] }}
          </span>
        </div>
        <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt tab-tilte-bg" style="line-height: 15px; padding-top: 5px;" :style="{ width: widthColumn[1] + 'px !important' }">
          <div>{{ sportTableLang.template_lang['SPORT_TEMPLATE_1.O/U'] }}</div>
          <span class="highlight-t">
            {{ sportTableLang.template_lang['SPORT_TEMPLATE_1.FIRST_HALF'] }}
          </span>
        </div>
        
        <template v-if="isUnfold">
          <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }" v-if="widthColumn[3]==0"></div>
          <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }" v-if="widthColumn[3]<2"></div>
          <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
          <div class="handicap-col fifteen-item bet-item-wrap fifteen_tab_txt" :style="{ width: widthColumn[1] + 'px !important' }"></div>
      </template>
    </template>
  </div>
</template>

<script>
import {
  mapGetters,
} from 'vuex'
import vueCookie from 'vue-cookie'

import DateFilter from '@/vue/filters/date'


// import allBetWD from './all-bet-wd'

// import allBetMixin from '../../../mixins/allBet'

import EventBus from '@/vue/events/event-bus'

export default {
  // mixins: [allBetMixin],
  components: {

    // moreCS,

  },
  props: {
    selMarket: null,
    event: null,
    widthColumn:null,
    isUnfold:false
  },
  computed: {
    ...mapGetters([
      'sportTableLang',
      'sportAllBetLang',
      // 'eventAllBet',
      // 'selectedShow',
      // 'moreBetLoading',
      // 'moreBetToggle',
      'simpleSport',
    ]),

  },
  data() {
    return {
      lang: window.lang,
      token: window.token,
    }
  },
  methods: {

  },
  beforeMount() {

  },
  destroyed() {
    // this.clearAllBetTimer()
  },
}
</script>

<style lang="scss">
@import "~@/styles/base/global";
// @import "~@/styles/sport/allBet/allBet";

.bluebg{
  background-color: var(--qq--yb-bg-color23);
}
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/more-bet-header.vue